/* eslint-disable */

export const facebookPostTemplate = {
  type: 'socialmediafacebookpost',
  title: 'Facebook Post',
  iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/generator\/templates\/facebook.svg',
  description: 'Generate amazing and contemporary facebook post that are relevant and on-trend.',
  category: {
    iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/generator\/templates\/categories\/social.svg',
    name: 'Social Media',
    key: 'social-media',
  },
  fieldsSchema: {
    title: {
      required: true,
      type: 'string',
      fieldType: 'input',
      minLength: 1,
      maxLength: 125,
      label: '',
      placeholder: 'Untitled Document',
      isMeta: false,
      order: 1,
      isEnableForDuplicate: false,
    },
    brandVoice: {
      required: false,
      type: [
        'null',
        'string',
      ],
      format: 'uuid',
      validate_callback: [
        'FemTexter\\Services\\Rest\\Validators\\Generator',
        'validateBrandVoiceByGuid',
      ],
      isMeta: false,
      default: null,
      isEnableForDuplicate: false,
    },
    topic: {
      required: true,
      type: 'string',
      fieldType: 'input',
      minLength: 2,
      maxLength: 150,
      isMeta: true,
      description: 'Tell us what topic the facebook post should be about. You can use keywords or a short sentence to explain the post.',
      label: 'Topic',
    },
    callToAction: {
      required: true,
      type: 'string',
      fieldType: 'input',
      minLength: 2,
      maxLength: 150,
      isMeta: true,
      description: 'Tell us what the Call to Action should be. You can for example use a CTA to direct readers to a product, a video or social media account or an email newsletter.',
      label: 'Call to Action',
    },
    language: {
      required: true,
      type: 'string',
      fieldType: 'select',
      validate_callback: [
        'FemTexter\\Services\\Rest\\Validators\\General',
        'validateLocale',
      ],
      enum: [
        'de_DE',
        'en_US',
      ],
      isMeta: false,
      placeholders: {
        de_DE: {
          iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/languages\/de.svg',
          label: 'Deutsch',
          value: 'de_DE',
        },
        en_US: {
          iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/languages\/uk.svg',
          label: 'English',
          value: 'en_US',
        },
      },
      label: 'Language',
      order: 70,
      isEnableForDuplicate: false,
    },
    toneOfVoice: {
      required: false,
      type: 'string',
      fieldType: 'select',
      enum: [
        'general',
        'professional',
        'encouraging',
        'funny',
        'dramatic',
        'witty',
        'sarcastic',
        'sad',
        'spirituel',
        'intellectual',
      ],
      placeholders: {
        general: 'General',
        professional: 'Professional',
        encouraging: 'Encouraging',
        funny: 'Funny',
        dramatic: 'Dramatic',
        witty: 'Witty',
        sarcastic: 'Sarcastic',
        sad: 'Sad',
        spirituel: 'Spirituel',
        intellectual: 'Intellectual',
      },
      isMeta: false,
      default: 'general',
      label: 'Tone of voice',
      order: 80,
      isEnableForDuplicate: false,
    },
    mood: {
      required: true,
      type: 'string',
      fieldType: 'select',
      label: 'Mood',
      enum: [
        'funny',
        'professional',
        'entertaining',
        'documentation',
        'do it yourself',
        'spirituel',
        'musician',
      ],
      placeholders: {
        funny: 'Funny',
        professional: 'Professional',
        entertaining: 'Entertaining',
        documentation: 'Documentation',
        'do it yourself': 'Do it yourself',
        spirituel: 'Spirituel',
        musician: 'Musician',
      },
      default: 'professional',
      isMeta: false,
      order: 90,
      isEnableForDuplicate: false,
    },
    wordsLength: {
      required: true,
      type: 'string',
      fieldType: 'select',
      label: 'Word limit',
      enum: [
        '50',
        '50-100',
        '100-300',
        '300-500',
        '500-1000',
        '1000-2000',
      ],
      placeholders: {
        50: '50',
        '50-100': '50-100',
        '100-300': '100-300',
        '300-500': '300-500',
        '500-1000': '500-1000',
        '1000-2000': '1000-2000',
      },
      default: '100-300',
      isMeta: false,
      order: 100,
      isEnableForDuplicate: false,
    },
  },
  documentFieldsSchema: [],
};

export const facebookPostGeneration = {
  type: 'generation',
  guid: 'ed5a3cf4-bec7-480e-912e-d7f86f1d2c69',
  title: 'asdf',
  template: {
    type: 'socialmediafacebookpost',
    title: 'Facebook Post',
    iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/generator\/templates\/facebook.svg',
    description: 'Generate amazing and contemporary facebook post that are relevant and on-trend.',
    category: {
      iconUrl: 'https:\/\/app.femtexter.dev\/cdn\/system\/generator\/templates\/categories\/social.svg',
      name: 'Social Media',
      key: 'social-media',
    },
  },
  updatedAt: {
    timestamp: 1_700_549_560,
    formatted: 'November 21, 2023 06:52:40',
  },
  createdAt: {
    timestamp: 1_700_549_560,
    formatted: 'November 21, 2023 06:52:40',
  },
  language: 'en_US',
  requestMessage: null,
  toneOfVoice: 'general',
  brandVoice: null,
  mood: 'professional',
  wordsLength: '100-300',
  meta: {
    topic: 'asdf',
    callToAction: 'asdf',
  },
  documents: [
    {
      guid: '2aa26efa-0186-43e4-9c06-fc2923a3f472',
      wordsCount: 352,
      updatedAt: {
        timestamp: 1_700_549_645,
        formatted: 'November 21, 2023 06:54:05',
      },
      title: 'asdf',
      coverImageUrl: null,
      rating: null,
      keywords: [],
      author: {
        displayName: 'femtexter_ full_access',
        domain: 'gesundheit.femtexter.tech',
        affiliate: {
          id: 'tina24',
          image: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/cd96832bbf07d1df93975743f4e13c54_1695305624.jpeg',
          displayName: 'gesundheitmann',
          link: 'https:\/\/www.digistore24.com\/content\/512173\/44926\/tina24\/campaignkey',
        },
      },
      isPublished: false,
      publicUrl: 'https:\/\/gesundheit.femtexter.tech\/doc\/2aa26efa-0186-43e4-9c06-fc2923a3f472.html',
      content: "<h2>Attention all food lovers!\uD83C\uDF54\uD83C\uDF55<\/h2>\n<h3>Introducing the All-Star Delicious Food Festival (ASDF)!<\/h3>\n<p>\uD83D\uDCE2 Calling all food enthusiasts, culinary connoisseurs, and\nflavor fanatics! Get ready to tantalize your taste buds because\nASDF is back and better than ever! \uD83D\uDE0B<\/p>\n<p>\uD83C\uDF1F Join us at the most anticipated food festival of the year!\nASDF showcases an array of gastronomical delights, from sizzling\nstreet food to mouthwatering gourmet creations, prepared by\nrenowned chefs from all over the world.<\/p>\n<p>\uD83C\uDF74 Immerse yourself in the world of culinary wonders as you\nembark on a food journey like no other. Indulge in exclusive dishes\ncurated by Michelin-star chefs, discover unique flavors from exotic\ncuisines, and savor every delicious morsel that ASDF has to\noffer.<\/p>\n<p>\uD83C\uDF89 With dozens of food stalls set up throughout the festival\ngrounds, you'll be spoilt for choice! From juicy burgers to\nstone-fired pizzas, spicy tacos to delectable desserts, there's\nsomething to satisfy every craving.<\/p>\n<p>\uD83D\uDCC5 Mark your calendars now! ASDF will take place from [date] to\n[date] at [location]. Bring your friends, family, and your appetite\nfor an unforgettable food experience.<\/p>\n<p>\u2728 Join us in celebrating the incredible world of food and be a\npart of the gastronomy extravaganza at ASDF!<\/p>\n<ol>\n<li>\uD83D\uDDFA\uFE0F Dates: [date] to [date]<\/li>\n<li>\uD83D\uDCCD Location: [location]<\/li>\n<li>\uD83D\uDD5B Festival Hours:\n<ul>\n<li>Monday to Friday: 12:00 PM - 10:00 PM<\/li>\n<li>Saturday and Sunday: 10:00 AM - 11:00 PM<\/li>\n<\/ul>\n<\/li>\n<\/ol>\n<p>\uD83D\uDC49 Don't miss out on this food lover's dream event! Get your\ntaste buds ready, gather your friends, and join us at ASDF for the\nultimate foodie delight!<\/p>\n<p>\uD83C\uDF81 Special offer: Refer three friends and get a 20% discount on\nyour entry ticket! Use the code \"ASDF2021\" when purchasing your\ntickets online.<\/p>\n<p>\uD83D\uDCF2 Book your tickets now and secure your spot at ASDF. Click the\nlink below to get started:<\/p>\n<br>\n<p><a href=\"https:\/\/www.asdfestival.com\/book-tickets\" target=\n\"_blank\"><strong>BOOK NOW<\/strong><\/a><\/p>\n<br>\n<p>\uD83C\uDF1F Get ready to embark on a culinary adventure like no other at\nASDF. We can't wait to see you there!<\/p>\n",
      meta: [],
      promptLog: 'Craft an engaging facebook post. use asdf for the content of the post and elaborate on it. Define a converting call to action with this input: asdf and add it to the post. The text should be approximately 100-300 words in length.  And write it in English language.',
    },
    {
      guid: '7a16d2f1-179a-4b15-8a9e-476322a4a516',
      wordsCount: 268,
      updatedAt: {
        timestamp: 1_700_549_628,
        formatted: 'November 21, 2023 06:53:48',
      },
      title: 'asdf',
      coverImageUrl: null,
      rating: null,
      keywords: [],
      author: {
        displayName: 'femtexter_ full_access',
        domain: 'gesundheit.femtexter.tech',
        affiliate: {
          id: 'tina24',
          image: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/cd96832bbf07d1df93975743f4e13c54_1695305624.jpeg',
          displayName: 'gesundheitmann',
          link: 'https:\/\/www.digistore24.com\/content\/512173\/44926\/tina24\/campaignkey',
        },
      },
      isPublished: false,
      publicUrl: 'https:\/\/gesundheit.femtexter.tech\/doc\/7a16d2f1-179a-4b15-8a9e-476322a4a516.html',
      content: "<h1>Exciting News!<\/h1>\n<p>\uD83D\uDCE3 Hey Friends! We have some incredible news to share with all of\nyou! \uD83C\uDF89<\/p>\n<p>\uD83C\uDF1F Introducing ASDF - <strong>Awesome Social Distancing\nFitness<\/strong> - the all-new fitness program designed to keep you\nactive and healthy without leaving your home! \uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F\uD83C\uDFE0<\/p>\n<br>\n<p>Packed with fun and effective workouts that you can do right\nfrom your living room, ASDF is here to help you stay fit and\nfabulous even during these challenging times. \uD83D\uDCAA\u2728<\/p>\n<br>\n<p>ASDF is not just another fitness routine; it's a revolutionary\nprogram that offers:<\/p>\n<ol>\n<li>A wide variety of workouts for all fitness levels<\/li>\n<li>Expert trainers to guide and motivate you every step of the\nway<\/li>\n<li>Flexible schedules that fit in with your busy lifestyle<\/li>\n<li>A supportive and inclusive community of fitness\nenthusiasts<\/li>\n<\/ol>\n<p>Join thousands of ASDF members who have already transformed\ntheir fitness journey from the comfort of their homes. The results\nhave been amazing, and we guarantee you won't be disappointed!\n\uD83C\uDF08<\/p>\n<br>\n<h2>Ready to take the ASDF challenge?<\/h2>\n<p>\uD83D\uDCA5 Sign up today and get an exclusive <strong>20%\ndiscount<\/strong> on your subscription! \uD83D\uDCAF\uD83C\uDF81<\/p>\n<br>\n<p>Simply click the link below to learn more and start your ASDF\nexperience:<\/p>\n<br>\n<h3><a href=\n\"www.asdfitnessprogram.com\">www.asdfitnessprogram.com<\/a><\/h3>\n<br>\n<p>\uD83D\uDC49 Don't miss out on this limited time offer! Start your ASDF\nfitness journey today and let's crush those fitness goals together!\n\uD83D\uDE80<\/p>\n<p><em>Disclaimer: Always consult with a healthcare professional\nbefore starting any new exercise program.<\/em><\/p>\n",
      meta: [],
      promptLog: 'Craft an engaging facebook post. use asdf for the content of the post and elaborate on it. Define a converting call to action with this input: asdf and add it to the post. The text should be approximately 100-300 words in length.  And write it in English language.',
    },
  ],
  documentsCount: 2,
};

export const createImageGeneration = [{
  title: null,
  guid: '4e6b817d-519b-4f95-90b8-db1d1a919023',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/1fae807305e68220121f5ce8a3dd8dd6_1700553940.jpeg',
},
{
  title: null,
  guid: 'd0fec224-dd0f-4f9a-9131-bd2a50054bc5',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/cef44a5b711747ac9b0277298b8d8c6e_1700553929.png',
},
{
  title: null,
  guid: 'f5031a16-3f86-4bb1-a1f4-ed6b47b72d95',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/a1d1e0ffdc150e614e8999264d201419_1700553921.jpeg',
},
{
  title: null,
  guid: '2c5a610d-a7aa-4686-8bf8-3c2b68276644',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/a1d1e0ffdc150e614e8999264d201419_1700553919.jpeg',
},
{
  title: null,
  guid: '02e9f315-db30-4c0d-a413-41a4a4e639ff',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/87aa8110293cb5501bc148eb73787965_1700477761.jpeg',
},
{
  title: null,
  guid: '462de22f-9b2d-4f86-871b-400b837fb916',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/125c873a768b5a06a865dc60999bf9d2_1700477760.png',
},
{
  title: null,
  guid: 'bb780808-5a5f-41f7-b24c-ea0ba7a6bb96',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/011b8a5aca007ee8540d07f54020173f_1700477755.jpeg',
},
{
  title: null,
  guid: '393d2336-8edd-4c35-8b3c-49bf5e7a2586',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/f65e87d492fefb9dfa97b48e7aec4cb1_1700477726.jpeg',
},
{
  title: null,
  guid: 'a343dffb-10b5-44e1-a6fa-1886d6cb2e86',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/920c5497d244e79c11f59219edd95c40_1700477717.jpeg',
},
{
  title: null,
  guid: 'd3295637-595c-4f00-80ce-bb2929bfd43c',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/ce6312ccbf59190641cfa978c5855a05_1700477714.jpeg',
},
{
  title: null,
  guid: '04a030e9-3542-4b3c-9d48-0275ade28f12',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/7f018eddcbffd75f121aa1038f1f200e_1700477709.png',
},
{
  title: null,
  guid: 'd9fc997d-2db2-4af6-b373-4019073a577a',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/2571ad89c15eb9c99b2071ac6c1091bd_1700477709.jpeg',
},
{
  title: null,
  guid: '932fa8d6-1fd7-4b66-9980-2879ca79f217',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/e21c9c70d841639ae12a012d4dbf20dc_1700475422.png',
},
{
  title: null,
  guid: 'fe006f13-be8f-4fc4-ae80-362f39d95747',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/2166b212bf5f53c236a3811db039b04b_1700475417.jpeg',
},
{
  title: null,
  guid: 'dd7ccb74-2769-404f-87a8-31ffe04880f7',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/5b39410166c207030132df92c3a15ab7_1700475415.jpeg',
},
{
  title: null,
  guid: 'b9bbc1b0-507d-4498-b751-91e86fe11a06',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/429b5caef6b8dcfb5f5bdd25184cece3_1700475413.jpeg',
},
{
  title: null,
  guid: '3cfdc975-b09d-4f93-8890-011de28a1e48',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/f5a91570c008a26610a1a393f110980c_1700229422.jpeg',
},
{
  title: null,
  guid: '0ad89846-f912-4050-96b3-c41c6c19afed',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/5489d0b10477ebac406f2a9861c41759_1700140858.png',
},
{
  title: 'demo_service',
  guid: 'c928aa8c-1509-41d1-94ff-dafafbee300d',
  mimeType: 'image\/png',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/5489d0b10477ebac406f2a9861c41759_1700140854.png',
},
{
  title: 'demo3',
  guid: '496227d5-3c74-4294-b5ce-c9d73fc37e8f',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/4396654995b7254057e0f73a8c43b0b8_1700140753.jpeg',
},
{
  title: null,
  guid: '8dc412b0-33d3-463b-bb36-897291fee45d',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/1d0d2bacca3c6e557825a509e4ce6402_1700140704.jpeg',
},
{
  title: null,
  guid: 'ca67714f-6ea8-4268-84dc-75bc30462352',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/6dba9b3e453a7e92f540432356235a12_1700140692.jpeg',
},
{
  title: null,
  guid: 'b5f3cf2b-0bd8-4a15-9fd0-ed347cce12ae',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/eb09b240c5a30e51db5f64cef56c6f1e_1700140681.jpeg',
},
{
  title: null,
  guid: '90ec0273-536a-4234-b872-db64391ecbb7',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/332bb523557bd98db15accd365744456_1700140667.jpeg',
},
{
  title: null,
  guid: '493e5150-3202-45e7-94f4-08e9af024d6b',
  mimeType: 'image\/jpeg',
  url: 'https:\/\/app.femtexter.dev\/cdn\/files\/c\/81\/dccfff0369efadf89df0153723c5c997\/50c9be13f799395a1bd5e21e20a5c22b_1700140659.jpeg',
}];
